import {
  highlightText,
  searchItems,
  searchItem,
} from '@/helpers/search-helpers'

export default {
  data: () => ({
    search: '',
  }),
  methods: {
    highlightText,
    searchItems,
    searchItem,
  },
}
